import { useCallback, useEffect } from 'react';
import { checkInBaggage, platinum } from '@eti/products';
import { useMutation } from '@apollo/client';
import { compose } from 'redux';
import { STORE_STATISTICS_MUTATION } from '../../payment/graphQL/mutations';

const uniqNumbers = (rawIds: (number | string)[]) => [
  ...new Set(
    rawIds.flatMap((id) => {
      const numberId = Number(id);
      if (!Number.isNaN(numberId)) {
        return numberId;
      }
      return [];
    }),
  ),
];

const useProductsOfferRate = (extraProducts: any[], pathname: string, selectionKey: string) => {
  const [storeStatistics] = useMutation(STORE_STATISTICS_MUTATION);

  const isPaymentPage = pathname === '/payment';
  const sendStatisticsIf = useCallback(
    (difference: number[], products: number[]) => {
      const offeredProducts = difference.filter((id: number) => products.includes(id));
      if (offeredProducts.length === 0) {
        return;
      }
      storeStatistics({
        variables: {
          brandedFareOffered: sessionStorage.getItem('brandedFareOffered') === 'true',
          offeredProducts: offeredProducts.map((id: number) => id.toString()),
          paymentRequest: isPaymentPage,
        },
      });
    },
    [storeStatistics, isPaymentPage],
  );

  useEffect(() => {
    sessionStorage.removeItem(selectionKey);
  }, [selectionKey]);

  useEffect(() => {
    const getAttributes = (elements: Element[]) =>
      elements.map((element) => element.getAttribute('data-offer-rate') || '');

    const productsInTheDom = compose(
      uniqNumbers,
      getAttributes,
    )([...document.querySelectorAll('[data-offer-rate]')]);

    const prevOfferedProducts = JSON.parse(sessionStorage.getItem(selectionKey) ?? '[]');
    const difference = productsInTheDom.filter((x) => !prevOfferedProducts.includes(x));

    if (difference.length === 0) {
      return;
    }

    sendStatisticsIf(difference, [checkInBaggage.id, platinum.id]);

    const combinedOfferedProducts = compose(
      JSON.stringify,
      uniqNumbers,
    )([...productsInTheDom, ...prevOfferedProducts]);

    sessionStorage.setItem(selectionKey, combinedOfferedProducts);
  }, [extraProducts, sendStatisticsIf, selectionKey]);
};

export default useProductsOfferRate;
